import { render, staticRenderFns } from "./AddBreederLineModal.vue?vue&type=template&id=68795b60"
import script from "./AddBreederLineModal.vue?vue&type=script&lang=js"
export * from "./AddBreederLineModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports